// A tab still running an older build asks for chunks that the deploy replaced.
// Cloudflare Pages keeps only the current deployment's hashed files, and for a
// missing one it answers 200 with index.html, so the dynamic import fails
// ("error loading dynamically imported module", "'text/html' is not a valid
// JavaScript MIME type"). For the locale chunks that left `translations` empty
// and every t() call rendered its raw key — Bugsnag 6a8f46f309ac4cce24f6b3a8,
// seen on main-cdb684e clients more than a week after main-861a797 shipped.
//
// Vite dispatches `vite:preloadError` on window whenever one of its wrapped
// dynamic imports rejects; in this app those are the locale JSON loaders
// (LanguageContext, Forms, forms/edit). Reloading fetches the current
// index.html (served must-revalidate) and with it chunk names that exist.
//
// Reload at most once per build: the guard stores the build that reloaded, so
// if the chunk still fails on that same build (blocked by an extension or proxy,
// an outage) the error is left to surface as it did before. Keying on the build
// rather than a time window keeps that true however slow the reload is — a
// window starting before reload() expires during a long boot and loops. A stale
// tab therefore reloads at most twice: once off the old build, once more only
// if the new build fails too.
//
// The guard needs real sessionStorage — the memory fallback in
// safeSessionStorage is wiped by the very reload it would be guarding — so
// without it no reload is attempted. The event is not preventDefault()ed: the
// import still rejects, so callers' existing fallbacks run until the reload
// replaces the page.

export const RELOAD_KEY = "staleChunkReloadBuild";

export function handlePreloadError(
  win = window,
  build = import.meta.env.VITE_APP_VERSION,
) {
  try {
    const storage = win.sessionStorage;
    if (storage.getItem(RELOAD_KEY) === String(build)) return false;
    storage.setItem(RELOAD_KEY, String(build));
  } catch {
    return false;
  }

  win.location.reload();
  return true;
}

export function installStaleChunkReload(win = window) {
  win.addEventListener("vite:preloadError", () => handlePreloadError(win));
}
